import React from "react"
import { StaticBackdropProps } from "../types/modal"

export const StaticBackdrop = (props: StaticBackdropProps) => {
    return (
        <div className="row ui-has-modules">
            <div className="col-12 ui-module mb-0">
                <div className="row p-2">
                    <div className="col-12 list-group">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/common/modal/StaticBackdrop.tsx